import {signFile} from "../functions/signProcessPage/SignFile";
import {useNavigate, useLocation} from "react-router-dom";
import {ServerApi} from "../api/ServerApi";
import {useEffect} from "react";

// Страница №5
// Подписание документов. Создание pdf и sig. Страница с loader.
export default function SignProcessPage() {
    const title = 'Страница 5. Подписание документов. Создание pdf и sig. Страница с loader.';
    const serverApi = new ServerApi();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const confirmationCode = location.state?.code || '';
        signFile(serverApi, navigate, title, confirmationCode);
    }, [location]);

    return (
        <div id={"main-page-wrapper"}>
            <div className={"justify-content-center"} id={"sign_loader"}>
                <div className={""}>
                    <h4 className={"text-center loader-text"}>Подписание документов</h4>
                    <div className={"progress ms-2"}>
                        <div className={"progress-bar h-100"}>
                            <div className={"progress-shadow"}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
